import { render, staticRenderFns } from "./CriteriaEditor.vue?vue&type=template&id=087f5f1e&"
import script from "./CriteriaEditor.vue?vue&type=script&lang=ts&"
export * from "./CriteriaEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CriteriaEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports